var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"livePlayer"},[_c('div',{staticClass:"sdk-wrap clearfix"},[_c('div',{staticClass:"sdk-wrap-left"},[_c('div',{staticClass:"mainScreen",attrs:{"id":"ppt"}}),_c('div',{staticClass:"subScreen",attrs:{"id":"player"}})]),_c('div',{staticClass:"chatroom",attrs:{"id":"wrap"}})])])
}]

export { render, staticRenderFns }